/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = _1 (1)
 * 
 * 401130001 = _2 (2)
 * 
 * 401130002 = _3 (3)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAcePrioritaet {
 _1 = 401130000,
 _2 = 401130001,
 _3 = 401130002
}

marker([
    "Enum.GlobalEnumsAcePrioritaet._1",
    "Enum.GlobalEnumsAcePrioritaet._2",
    "Enum.GlobalEnumsAcePrioritaet._3"
]);

export namespace GlobalEnumsAcePrioritaet
{
    class DataSets
    {
        static GlobalEnumsAcePrioritaetDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("_1", 401130000, "1"),
            new EnumValue("_2", 401130001, "2"),
            new EnumValue("_3", 401130002, "3"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAcePrioritaetDataSet;
    }
}
